import { render, staticRenderFns } from "./CriticaDespesa.vue?vue&type=template&id=39d3928a"
import script from "./CriticaDespesa.vue?vue&type=script&lang=js"
export * from "./CriticaDespesa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports